module.exports = __webpack_public_path__ + "static/media/logo.9a62e696.svg";